/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_DisableInputs */

const en_common_disable = /** @type {(inputs: Common_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disable`)
};

const es_common_disable = /** @type {(inputs: Common_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshabilitar`)
};

/**
* | output |
* | --- |
* | "Disable" |
*
* @param {Common_DisableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_disable = /** @type {((inputs?: Common_DisableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_DisableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_disable(inputs)
	return en_common_disable(inputs)
});